<ng-conatiner *ngIf="viewLocation !== taxonyDetailEnum">
    <div *ngIf="showNavigation"
        class="node-navigate d-flex justify-content-between align-items-start">
        <button
            class="btn btn-common tooltip right font-1x position-relative custom-icon-size"
            id="prevarrowBtn"
            [attr.aria-label]="'Previous Node'"
            data-tooltip="Previous node"
            [disabled]="selectedNode?.isFirst === true || selectedNode?.id === firstNode?.id"
            (click)="onTreeNavigatePreviousClick()">
            <em aria-hidden="true" class="material-icons-outlined font-4x button-icon">
                west
            </em>
        </button>

        <button
            class="btn btn-common tooltip right font-1x position-relative custom-icon-size"
            id="nextarrowBtn"
            [attr.aria-label]="'Next Node'"
            data-tooltip="Next node"
            [disabled]="selectedNode?.id === lastNode?.id"
            (click)="onTreeNavigateNextClick()">
            <em aria-hidden="true" class="material-icons-outlined font-4x button-icon">
                east
            </em>
        </button>
        <span class="preview-panel--nav-helper text-uppercase text-center">
            Navigate
        </span>
    </div>
</ng-conatiner>

<ng-container *ngIf="viewLocation === taxonyDetailEnum">
    <div class="node-navigate d-flex justify-content-between align-items-start">
        <button
            class="btn btn-common tooltip right font-1x position-relative custom-icon-size"
            id="prevarrowBtn"
            [attr.aria-label]="'Previous Node'"
            data-tooltip="Previous node"
            [disabled]="firstNode?.document_id ? selectedNode?.document_id === firstNode?.document_id : false"
            (click)="onTreeNavigatePreviousEvent()">
            <em aria-hidden="true" class="material-icons-outlined font-4x button-icon">
                west
            </em>
        </button>

        <button
            class="btn btn-common tooltip right font-1x position-relative custom-icon-size"
            id="nextarrowBtn"
            [attr.aria-label]="'Next Node'"
            data-tooltip="Next node"
            [disabled]="lastNode?.has_children !== 'true' && selectedNode?.item_id === lastNode?.item_id"
            (click)="onTreeNavigateNextEvent()">
            <em aria-hidden="true" class="material-icons-outlined font-4x button-icon">
                east
            </em>
        </button>
        <span class="preview-panel--nav-helper text-uppercase text-center">
            Navigate
        </span>
    </div>
</ng-container>